import {request, request_op} from "../plugins/axios";

//获取雷达数据
export function getRadarApi (params) {
    return request({
        url: '/radar/getRadar',
        method: 'GET',
        params: params
    })
}

//获取微信用户信息
export function openUserInfoApi (params) {
    return request_op({
        url: '/openUserInfo/radar',
        method: 'GET',
        params: params
    })
}
// 提交阅读回调
export function getRadar (params) {
    return request({
        url: '/radar/readCallback',
        method: 'GET',
        params: params
    })
}
